module.exports = __webpack_public_path__ + "static/img/icon-warn.fc7ee86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-warn.jpg
// module id = sZwS
// module chunks = 21